import classNames from "classnames";
import React, { Component } from "react";
import "../../../../styles/main.scss";

interface KuikaH8Props extends React.HTMLAttributes<HTMLHeadingElement> {
  children: React.ReactNode;
}

class KuikaH8 extends Component<KuikaH8Props> {
  render() {
    const { children, className, ...props } = this.props;

    return (
      <h6 className={classNames("kuika-typography-h8", className)} {...props}>
        {children}
      </h6>
    );
  }
}

export default KuikaH8;
